import HeaderTitle from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import { LpBox } from 'Constants/styles';

import InvoiceList from './InvoiceList';

const Invoices = () => {
  return (
    <div className="mb-4">
      <HeaderTitle title="Invoices" />
      <Content>
        <LpBox>
          <InvoiceList />
        </LpBox>
      </Content>
    </div>
  );
};

export default Invoices;
